import { Divider } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { OrderActions } from './order-actions';
import { cn } from '@src/utils/ui';
import { ConfirmTaskButton } from '@src/components/common/confirm-task-button/confirm-task-button';
import { formatDateTime } from '@src/utils/date/formatDateTime';

export const OrderCards = props => {
    const items = useWatch({ name: 'items' });

    return (
        <div className='tw-space-y-[16px] lg:tw-d-none'>
            {items?.map(order => (
                <Card key={order.id} order={order} {...props} />
            ))}
        </div>
    );
};

const Card = props => {
    const { order, buyerView } = props;
    order.isFulfillEnabled = order.isFulfillEnabled && moment().isSameOrAfter(moment.unix(order.taskDate));

    return (
        <a
            href={`/${buyerView ? 'purchase' : 'merchants/order'}/detail/${order.invoiceNo}`}
            className='tw-block tw-text-[#212124]'
        >
            <div className='tw-space-y-[8px] tw-p-[16px] tw-pb-[8px] tw-border tw-border-[#0050C4]'>
                <div className='tw-grid tw-grid-cols-2 tw-gap-[8px] tw-items-center'>
                    <div>
                        <div className='tw-font-medium'>Order Number</div>
                        <span className='tw-text-[#0050C4] tw-underline'>{order.orderNumber}</span>
                    </div>
                    <div>
                        <div className='tw-font-medium'>{buyerView ? 'Provider' : 'Customer'}</div>
                        <div>{buyerView ? order.providerName : order.customerName}</div>
                    </div>
                    <div>
                        <div className='tw-font-medium'>Order Issue Date</div>
                        <div>{formatDateTime(order.orderIssueDate, 'MM/DD/YYYY')}</div>
                    </div>
                    <div>
                        <div className='tw-font-medium'>Order Status</div>
                        <div>{order.orderStatus}</div>
                    </div>
                    <div>
                        <div className='tw-font-medium'>Total</div>
                        <div>{numeral(order.total).format('$0,0.00')}</div>
                    </div>
                    <div>
                        <div className='tw-font-medium'>Task Date</div>
                        <div>{formatDateTime(order.taskDate, 'MM/DD/YYYY')}</div>
                    </div>
                </div>
                <Divider />
                {order.isCreatedInBookNow && !props.buyerView ? (
                    <div className='tw-text-[#0050C4] tw-font-[500] tw-w-full tw-text-end'>Via Book Now</div>
                ) : null}

                <div className='tw-flex tw-justify-between tw-gap-[8px] tw-items-center tw-flex-nowrap'>
                    {!props.buyerView ? (
                        <ConfirmTaskButton
                            channelId={order.channelId}
                            orderId={order.id}
                            confirmOrder={props.confirmOrder}
                            isCreatedInBookNow={order.isCreatedInBookNow}
                        />
                    ) : null}
                    <div
                        className={cn([
                            'tw-flex tw-gap-[8px] tw-flex-nowrap tw-items-center',
                            !props.buyerView && order.isCreatedInBookNow
                                ? 'tw-justify-end'
                                : 'tw-justify-between tw-w-full'
                        ])}
                    >
                        <OrderActions
                            orderId={order.id}
                            isEnabled={order.isFulfillEnabled}
                            isCreatedInBookNow={order.isCreatedInBookNow}
                            fulfillOrder={props.fulfillOrder}
                            fulfillmentStatus={order.fulfillmentStatus}
                            onCancelAndRefund={props.cancelAndRefund}
                            buyerView={props.buyerView}
                            taskDate={order.taskDate}
                            total={order.total}
                            channelId={order.channelId}
                            itemId={order.itemId}
                            cartId={order.cartId}
                            buyerHasSubmittedReview={order.buyerHasSubmittedReview}
                            submitFeedbackForCartItem={props.submitFeedbackForCartItem}
                        />
                    </div>
                </div>
            </div>
        </a>
    );
};

OrderCards.propTypes = {
    buyerView: PropTypes.bool,
    fulfillOrder: PropTypes.func,
    cancelAndRefund: PropTypes.func
};

Card.propTypes = {
    ...OrderCards.propTypes,
    order: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        orderNumber: PropTypes.string,
        invoiceNo: PropTypes.string,
        orderIssueDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        orderStatus: PropTypes.string,
        fulfilmentStatus: PropTypes.string,
        fulfillmentStatus: PropTypes.string,
        providerName: PropTypes.string,
        customerName: PropTypes.string,
        channelId: PropTypes.string,
        total: PropTypes.number,
        taskDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        itemId: PropTypes.string,
        cartId: PropTypes.string,
        buyerHasSubmittedReview: PropTypes.bool
    }).isRequired
};
